// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    events: {
        id: 'logs-timeline.events',
        defaultMessage: 'Events'
    },
    Motion: {
        id: 'logs-timeline.motion',
        defaultMessage: 'Motion'
    },
    Opened: {
        id: 'logs-timeline.opened',
        defaultMessage: 'Opened'
    },
    Closed: {
        id: 'logs-timeline.closed',
        defaultMessage: 'Closed'
    },
    motionDetected: {
        id: 'logs-timeline.motion-detected',
        defaultMessage: 'Motion Detected'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/logs/info/intl.js